var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('transition',{attrs:{"name":"splash-fade"}},[(_vm.showSplash)?_c('SplashOverlay',{on:{"done":function($event){_vm.showSplash = false}}}):_vm._e()],1),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }